// 快捷菜单
import httpRequest from '@/utils/request.js';
/**获取快捷菜单 */
export const getShortCut = (params = {}) => httpRequest.httpGet({
    url: '/service/mine/shortcut', params: {
        ...params
    }
})

/**获取快捷菜单树 */
export const getMenuTree = (params = {}) => httpRequest.httpGet({
    url: '/service/mine/shortcutMenu', params: {
        ...params
    }
})

/**添加快捷菜单 */
export const addShortCut = (ids) =>  httpRequest.httpPost('/service/mine/addShortcut', ids)

